export default "__VITE_ASSET__BNGp$OQ1__"